import { Spin } from 'antd'
import styled from 'styled-components'
import { dimens } from '../shared-constants/dimens'
import { colors } from '../shared-constants/colors'

interface IProps {
  color?: string
  size?: string //small or large
  cMargin?: string
}

const CustomLoading = ({
  color = colors.PRIMARY,
  size = 'large',
  cMargin = dimens.SPACING_M,
}: IProps) => {
  return (
    <SpinnerContainer cMargin={cMargin}>
      <CustomSpinner size={size} color={color} />
    </SpinnerContainer>
  )
}

export default CustomLoading

interface PropsStyled {
  color: string
}

const SpinnerContainer = styled.div<any>`
  display: flex;
  justify-content: center;
  margin-top: ${(props) => props.cMargin};
`

const CustomSpinner = styled(Spin)<PropsStyled>`
  .ant-spin-dot-item {
    background-color: ${(props) =>
      props.color ? props.color : colors.PRIMARY};
  }
`
